import React from 'react';
import { connect } from 'react-redux';
import formFieldsHandler from 'decorators/FormFieldsHandler';
import ensureCart from 'decorators/Cart';
import Header from './_layout/Header';
import Footer from './_layout/Footer';
import Portrait from './_layout/Portrait';
import Landscape from './_layout/Landscape';
import Sidebar from './_layout/Sidebar';
import classnames from 'classnames';

import {
  Row,
  Columns,
} from 'views/Grid';

import { getUrlParameterByName } from 'config/utils';
import root from 'window-or-global';

import {
  getOfferErrorCode,
  getIsUserOwner,
  getIsImagePortrait,
  getIsStoreEnabled,
  getImagePreview,
  getIsCartEnabled,
} from '../reducers/ProductReducers';

import {
  getIsShowCartModal,
} from 'reducers/CartReducers';

import {
  handleToggleCartModal,
  handleInitCartError,
} from 'actions/CartActions';

class Product extends React.Component {
  constructor () {
    super();
    this.state = {
      Admin: () => <span></span>,
    };
  }

  componentDidMount () {
    if (getUrlParameterByName('intent') === 'buy') {
      root.isPaymentButtonClicked = true;
    }

    if (this.props.isCartEnabled) {
      const error = getUrlParameterByName('error');
      if (error) {
        this.props.handleInitCartError({
          error,
        });
      }
    }

    if (this.props.admin) {
      require.ensure([], (require) => {
        const Admin = require('admin/Admin').default;
        this.setState({
          Admin,
        });
      });
    }
  }

  render () {
    const {
      isImagePortrait,
      isStoreEnabled,
      isCartEnabled,
      preview,
      isUserOwner,
      errorCode,
      handleToggleCartModal,
    } = this.props;

    const showSideBar = isStoreEnabled || (isUserOwner && errorCode);

    const contentClassname = classnames('small-12 medium-8 soft--top', {
      'medium-centered': !showSideBar,
    });

    const { Admin } = this.state;

    return (
      <div>
        <Admin
          {...this.props.admin}
        />
        <Header
          isCartEnabled={isCartEnabled}
          onShowCart={() => handleToggleCartModal()}
        />
        <Row className="soft--bottom collapse">
          <Columns className={contentClassname}>
            { isImagePortrait || !preview ?
              <Portrait /> :
              <Landscape />
            }
          </Columns>
          { showSideBar ?
            <Columns className="small-12 medium-4 soft--top sidebar-column">
              <Sidebar />
            </Columns> :
            null
          }
        </Row>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = ({ product, cart, admin }) => ({
  errorCode: getOfferErrorCode(product),
  isUserOwner: getIsUserOwner(product),
  isImagePortrait: getIsImagePortrait(product),
  isStoreEnabled: getIsStoreEnabled(product),
  isCartEnabled: getIsCartEnabled(product),
  isShowCartModal: getIsShowCartModal(cart),
  preview: getImagePreview(product),
  isProductPage: true,
  admin,
});

// exported to waggle as well
export default connect(mapStateToProps, {
  handleToggleCartModal,
  handleInitCartError,
})(ensureCart(formFieldsHandler(Product)));



// WEBPACK FOOTER //
// ./src/product/views/Product.js